module.exports = __webpack_public_path__ + "img/BINDI 3 LIME.309a42a.svg";